var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MTableCell',{staticClass:"m-table-cell__icon-hint"},[(_vm.hint)?_c('MHint',{attrs:{"reference-selector":`#${_vm.id}`,"visible-arrow":false,"popper-options":{modifiers: {
      preventOverflow: {
        enabled: true
      }
    }}}},[_c('MIcon',{attrs:{"id":_vm.id,"icon":_vm.icon}}),_vm._v(" "),_c('template',{slot:"content"},[_vm._v("\n      "+_vm._s(_vm.hint)+"\n    ")])],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }